<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div>

        </div>
        <div class="card card-competencias">
          <div class="card-header">
            <h4 class="card-title">Como usar?</h4>
            <p class="category">Seguem abaixo os vídeos de suporte a utilização da Avaliação de Desempenho.</p>
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col-md-12" style="padding-bottom: 5px;">
                <a href="https://www.youtube.com/watch?v=bZp53Q5SOns&feature=youtu.be" target="_blank" style="width: 100%; text-align: left;" class="btn btn-default">
                  <span style="color: red;"><i class="fa fa-youtube-play" aria-hidden="true"></i></span> Primeiros passos
                </a>
              </div>
              <div class="col-md-12" style="padding-bottom: 5px;">
                <a href="https://www.youtube.com/watch?v=0XzUu0uyVAk&feature=youtu.be" target="_blank" style="width: 100%; text-align: left;" class="btn btn-default">
                  <span style="color: red;"><i class="fa fa-youtube-play" aria-hidden="true"></i></span> Avaliação Versão Gestor
                </a>
              </div>
              <div class="col-md-12" style="padding-bottom: 5px;">
                <a href="https://www.youtube.com/watch?v=LQLlzPo3hL4&feature=youtu.be" target="_blank" style="width: 100%; text-align: left;" class="btn btn-default">
                  <span style="color: red;"><i class="fa fa-youtube-play" aria-hidden="true"></i></span> Avaliação Versão Colaborador
                </a>
              </div>
              <div class="col-md-12" style="padding-bottom: 5px;">
                <a href="https://www.youtube.com/watch?v=ietJNNsnd0E&ab_channel=PortalBrasal" target="_blank" style="width: 100%; text-align: left;" class="btn btn-default">
                  <span style="color: red;"><i class="fa fa-youtube-play" aria-hidden="true"></i></span> Me avalia aí! Versão Colaborador
                </a>
              </div>
              <div class="col-md-12" style="padding-bottom: 5px;">
                <a href="https://www.youtube.com/watch?v=fXyEN26B83Y&ab_channel=PortalBrasal" target="_blank" style="width: 100%; text-align: left;" class="btn btn-default">
                  <span style="color: red;"><i class="fa fa-youtube-play" aria-hidden="true"></i></span> Me avalia aí! Versão Gestor
                </a>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/InfoVideo.vue